import React, { useState, useEffect, useContext } from 'react';
// AUTH
import { AuthContext } from '../contexts/AuthContext';
// REACT ROUTER
import { useNavigate, useLocation } from 'react-router-dom';
// REACT SPINNER
import { Watch } from 'react-loader-spinner';
// AXIOS
import axios from 'axios';
// REACT HOOK FORM
import { useForm } from "react-hook-form";
// REACT SELECT
import Select from 'react-select';
// REACT SWEETALERT
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
// BOOTSTRAP
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// ICONS
import { FaUpload } from 'react-icons/fa';
// DYNAMIC ICON
import DynamicIcon from '../partials/DynamicIcon';

function ImportActivities() {
  // AUTH, STATE, NAVIGATION
  const { authobj } = useContext(AuthContext);
  const { state } = useLocation();
  let navigate = useNavigate();
  // FORM
  const { register, handleSubmit, reset, setValue } = useForm();
  // DATA
  const [suppliers, setSuppliers] = useState([]);
  const [selectSuppliers, setSelectSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  // SPINNER
  const [wait, setWait] = useState(false);
  // SWEETALERT
  const MySwal = withReactContent(Swal);

  useEffect(() => {
    axios.post(window.SERVER_URL+'suppliers/list', {}, { headers: {
      'Access-Control-Allow-Origin': '*',
      'Authorization': 'Bearer '+authobj.token
    }}).then(res => {
      setSuppliers(res.data.suppliers);
      let select_options = [];
      res.data.suppliers.map((sup) => {
        select_options.push({ value: sup.id, label: sup.ragione_sociale });
      });
      setSelectSuppliers(select_options);
    });
  }, []);

  // Submit della form
  const onSubmit = (form_data) => {
    setWait(true);

    console.log(form_data);
    if (form_data.activities) {
      const formData = new FormData();
      formData.append('file', form_data.activities[0]);
      formData.append('type', 'activities');
      formData.append('supplier_id', (selectedSupplier ? selectedSupplier.value : null));
      axios.post(window.SERVER_URL+'import', formData, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': 'Bearer '+authobj.token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res.data);

        setWait(false);

        if (res.data[0]) {
          Swal.fire({
            icon: 'success',
            title: 'Dati importati',
            html: res.data[1]
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            html: res.data[1]
          });
        }
      }).catch(function(error) {
        setWait(false);
        console.log(error);
        Swal.fire({
          icon: 'error',
          title: 'Errore',
          html: error
        });
      });
    } else {
      setWait(false);

      Swal.fire({
        icon: 'error',
        title: 'File mancante',
        text: "Devi caricare un file con le attività"
      });
    }
  }

  return (
    <>
      { wait ? 
        <div id="wait">
          <Watch height="80" width="80" radius="48" color="#44B2EB" ariaLabel="watch-loading" wrapperStyle={{}} wrapperClassName="" visible={true} />
        </div>
      : '' }
      <Container className="content">
        <Row className="page_title">
          <Col>
            <h1>Importa attività</h1>
          </Col>
        </Row>
        <form className="custom_form" onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col style={{margin:'0 20px'}}>
              <label style={{textAlign: 'left'}}>Fornitore</label>
              <Select value={selectedSupplier} required={true} isDisabled={false} isLoading={false} isClearable={true} isRtl={false} isSearchable={true} name="supplier_id" options={selectSuppliers} onChange={(e) => setSelectedSupplier(e)} />
            </Col>
            <Col style={{margin:'0 20px'}}>
              <label style={{textAlign: 'left'}}>File da importare</label>
              <input type="file" name="activities" {...register("activities", { required: "Il file da importare è obbligatorio" })} />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button type="submit" variant="success" className="waste_btn" style={{'width':'320px'}}><FaUpload /> Importa attività</Button>
            </Col>
          </Row>
        </form>
        <hr /><br />
        <Row>
          <Col>
            <h2>Scarica il template in formato excel</h2>
            <Button style={{'marginLeft':'40px'}} title="Scarica file template" onClick={() => { window.open(window.SERVER_URL.replace('api/', '')+'download/activities.xlsx'); }}><DynamicIcon iconName="FaDownload" /> SCARICA FILE TEMPLATE</Button>
          </Col>
          <Col>
            <h2>Spiegazione utilizzo</h2>
            <p>Il file template può essere utilizzato per caricare <b>3 diverse casistiche</b>:</p>
            <ol>
              <li>Attività <b>su un pezzo singolo</b> con matricola (serbatoio, contatore, estintore o valvola)</li>
              <li>Attività <b>su tutti i pezzi di un certo tipo</b> (contatori, estintori o valvole) <b>collegati a un certo serbatoio</b></li>
              <li>Attività <b>su tutti i pezzi di un certo tipo</b> (serbatoi, contatori, estintori o valvole) <b>in un certo comune</b></li>
            </ol>
            <p>Il <b>CASO 1</b> è l'unico che può <b>creare delle nuove entità o aggiornare i dati esistenti</b>, mentre i CASI 2 e 3 servono per creare operazioni sulle entità già presenti nel gestionale</p>
            <p>Nei CASI 2 e 3 <b>FARE ATTENZIONE A NON COMPILARE</b> i dati anagrafici</p>
            <Row>
              <Col className='colDetail'>
                <h3>CASO 1</h3>
                Riempire le colonne:
                <ul>
                  <li>Tipo operazione</li>
                  <li>Matr. serbatoio</li>
                  <li>Tipo entità</li>
                  <li>Matr. entità</li>
                  <hr />
                  <li>Comune</li>
                  <li>Sede tecnica</li>
                  <li>Denominazione</li>
                  <li>Indirizzo</li>
                  <li>Latitudine</li>
                  <li>Longitudine</li>
                  <li>Telefono</li>
                  <li>Cellulare</li>
                  <li>Email</li>
                </ul>
              </Col>
              <Col className='colDetail'>
                <h3>CASO 2</h3>
                Riempire le colonne:
                <ul>
                  <li>Tipo operazione</li>
                  <li>Matr. serbatoio</li>
                  <li>Tipo entità scegliendo "Serbatoio"</li>
                  <li>Tipo sottoentità</li>
                  <li>Matr. entità scrivendo <b>T</b></li>
                </ul>
              </Col>
              <Col className='colDetail'>
                <h3>CASO 3</h3>
                <ul>
                  <li>Tipo operazione</li>
                  <li>Tipo entità</li>
                  <li>Matr. entità scrivendo <b>T</b></li>
                  <li>Comune</li>
                </ul>
              </Col>
            </Row>
            <div style={{'background':'yellow','padding':'20px','marginTop':'40px'}}>
            <h2>ATTENZIONE!</h2>
            <b>È possibile caricare 100 righe alla volta con il file Excel</b>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ImportActivities;